var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8212 10.6172C19.9251 10.793 19.9251 11.0273 19.8212 11.2031L17.9717 14.1914C17.8678 14.3672 17.66 14.4844 17.4315 14.4844C17.2029 14.4844 16.9951 14.3672 16.8912 14.1914L15.0417 11.2031C14.9378 11.0273 14.9378 10.793 15.0417 10.6172C15.1456 10.4414 15.3534 10.3242 15.582 10.3242H19.2601C19.4887 10.3242 19.6965 10.4414 19.8212 10.6172ZM11.8207 16.7109C11.8207 17.043 11.6545 17.2969 11.4373 17.2969H2.74897C2.53181 17.2969 2.36557 17.043 2.36557 16.7109V7.33594C2.36557 7.00391 2.53181 6.75 2.74897 6.75H11.4373C11.6545 6.75 11.8207 7.00391 11.8207 7.33594V16.7109ZM3.06255 5.57812C1.75192 5.57812 0.703125 5.76562 0.703125 7.33594V16.7109C0.703125 18.4688 1.75192 18.4688 3.06255 18.4688H20.8906C22.2012 18.4688 23.25 18.2812 23.25 16.7109V7.42969C23.3906 6.04688 22.2012 5.57812 20.8906 5.57812H3.06255Z",
    fill: "#252525"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.3067b1747627586ca757626b54b7a3c9.svg";
export { ForwardRef as ReactComponent };